module.exports = __webpack_public_path__ + "static/assets/3acfb7e386938ff52f063a3742bc2ebb.svg";